import { createContext } from 'react';

export const ModuleNameContext = createContext('');
